import styled from 'styled-components';
import { Button, Form, Modal, Space } from 'antd';
import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';

const CARDS_LAYOUT_QUERY = `(max-width: ${RESPONSIVE_BREAKPOINTS.table - 1}px)`;

export const ModalHeader = styled.div`
  background-color: #f78e1e;
  padding: 24px;
  > span {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
  @media ${CARDS_LAYOUT_QUERY} {
    padding: 16px;
    > span {
      font-size: 18px;
    }
  }
  .ant-col {
    > span {
      color: #fff;
      font-size: 20px;
      font-weight: 500;
    }
    button {
      font-size: 14px;
      max-width: 98px;
      background-color: #f78e1e;
      border-color: #fff;
      color: #fff;
      &:hover {
        background-color: #fff;
        color: #f78e1e;
      }
    }
  }
`;
export const ModalBody = styled.div`
  margin-top: -20px;
  padding: 24px;
  @media ${CARDS_LAYOUT_QUERY} {
    flex: 1;
    margin-top: 0;
    padding: 8px 16px 16px;
    .site-navigation-steps.ant-steps-navigation {
      flex-direction: row;
      padding-top: 0;
      margin-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;
    }
    .site-navigation-steps .ant-steps-item {
      flex: 1 1 0;
      margin: 0 !important;
      padding: 0;
      text-align: center;
      &::after {
        display: none;
      }
      &::before {
        left: 0;
        width: 100%;
        background-color: #f78e1e;
      }
    }
    .site-navigation-steps .ant-steps-item-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 44px;
      margin-left: 0;
      padding: 0 8px;
    }
    .site-navigation-steps .ant-steps-item-icon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      font-size: 12px;
      line-height: 22px;
    }
    .site-navigation-steps .ant-steps-item-content {
      display: inline-flex;
      min-height: auto;
    }
    .site-navigation-steps .ant-steps-item-title {
      padding-right: 0;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
    }
    .site-navigation-steps .ant-steps-item-active .ant-steps-item-title {
      color: #f78e1e;
      font-weight: 500;
    }
  }
`;

export const ModalFooter = styled.div`
  padding: 24px;
  border-top: 1px solid #d9d9d9;
  @media ${CARDS_LAYOUT_QUERY} {
    position: sticky;
    bottom: 0;
    z-index: 2;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: #fff;
  }
`;

export const ModalAdd = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-close {
    display: none;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  @media ${CARDS_LAYOUT_QUERY} {
    &.ant-modal {
      top: 0;
      width: 100vw !important;
      max-width: 100vw;
      margin: 0;
      padding-bottom: 0;
    }
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      min-height: 100dvh;
      border-radius: 0;
    }
    .ant-modal-body {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
  }
`;

export const ContentButtons = styled(Space)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
  margin-top: 15px;
`;

export const ModalHeaderAdd = styled.div`
  background-color: #f78e1e;
  padding: 24px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  span {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
`;
export const ModalBodyAdd = styled.div`
  padding: 24px;
`;

export const AddForm = styled(Form)`
  width: 100%;
`;

export const ModalFooterInformationText = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content:space-between;
    margin-bottom: -7px; 
    margin-right: 15px;
    > p {
        text-align: start;
        margin: 0;
        margin-right: 8px;
        padding-bottom: 16px;
        margin-bottom: -3px;
        color: #8c8c8c;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
    } 
    > span {
        text-align: start;
        color: #353839;
        padding-bottom: 16px;      
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
    }
`;

export const MobileFooterTotal = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
  > p {
    margin: 0;
    color: #8c8c8c;
    font-size: 14px;
  }
  > span {
    color: #353839;
    font-size: 20px;
    font-weight: 700;
  }
`;

export const MobileFooterButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const MobileFooterButton = styled(Button)`
  height: 44px;
`;
